import JCard from "./JCard";

export { JCard }
export default JCard
